import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "down-carat",
  "use": "down-carat-usage",
  "viewBox": "0 0 12 8",
  "content": "<symbol viewBox=\"0 0 12 8\" fill=\"#none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"down-carat\">\n<path d=\"M10.59 0L6 4.58L1.41 0L0 1.41L6 7.41L12 1.41L10.59 0Z\" fill=\"#fff\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol